import React from 'react';
import { motion } from 'framer-motion';

// El vídeo de una edición.
//
// No se escribe aquí: sale del bloque "video" de esa edición en
// festivalData.json. Con "actiu": false, o sin identificador, no se pinta nada
// y la página queda exactamente como estaba.
//
// Solo hace falta el identificador del vídeo, no el código de incrustar: para
// vimeo.com/1117703660 el identificador es 1117703660, y para
// youtube.com/watch?v=wcuufHlsAYE es wcuufHlsAYE.
const SRC = {
  vimeo: (id) => `https://player.vimeo.com/video/${id}?dnt=1&title=0&byline=0&portrait=0`,
  youtube: (id) => `https://www.youtube-nocookie.com/embed/${id}?rel=0`,
};

export const VideoEdicio = ({ video, titol }) => {
  if (!video || !video.actiu || !video.id) return null;

  const build = SRC[video.proveidor];
  if (!build) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
      data-testid="edicio-video"
      className="mt-10 overflow-hidden rounded-2xl border border-[var(--cea-border-strong)] bg-black"
    >
      <div className="aspect-video">
        <iframe
          src={build(video.id)}
          title={titol}
          loading="lazy"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          className="h-full w-full border-0"
        />
      </div>
    </motion.div>
  );
};
